import React from 'react'

import Baptisms from '../components/Baptisms';


function Dashboard() {

  

return (
    <div>
            {/* <Announcements></Announcements> */}
            <Baptisms></Baptisms>

    </div>
)
}
export default Dashboard